/*
<summary>
   This functional common component shows loader only for the duration of getting data from api.
   Developer:Aashish Singh, Created Date:28-Aug-2022
</summary>
<returns>Returns JSX</returns>
*/
import React from 'react';
import BusyGif from '../../assets/Images/busy.gif';
import './FormLoader.css';

interface IProps {
  loading: boolean;
  // When true, the loader is confined to its nearest positioned ancestor
  // (e.g. the modal-content box) instead of covering the whole viewport.
  contained?: boolean;
}

const FormLoader = (props: IProps) => {
  return props.loading ? (
    <div
      className={`loaderContainer ${
        props.contained ? 'loaderContainer-contained' : 'loaderContainer-fixed'
      }`}
    >
      <img
        className="form-loader-img"
        src={BusyGif}
        alt="loading..."
      />
    </div>
  ) : null;
};

export default FormLoader;
